import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Componentes
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import usuario_api from '../../../api/usuario_api';
import infracoes_api from '../../../api/infracoes_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos, isDateOverflow } from '../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../helpers/onChangeMultiSelect';
import mascaras from '../../../helpers/mascaras';
import { formatDataHora } from '../../../helpers/formatDataHora';
import { getSessionCookie } from '../../../helpers/cookies';

//Context
import { useAuth } from '../../../context/auth';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
import { useLocation, useNavigate } from 'react-router-dom';


function initialStateConsultaInfracao() {
  const dataInicial = new Date();
  dataInicial.setMonth(dataInicial.getMonth() - 1);

  return {
    tipoFiscalizacao_Ids: [],
    infracao_Id: "",
    dataInfracaoInicial: moment(dataInicial).format("YYYY-MM-DD"),
    dataInfracaoFinal: moment(new Date()).format("YYYY-MM-DD"),
    usuario_Id: "",
    nomeInfrator: "",
    situacao: "",
    numeroInfracao: "",
    cpfcnpj: "",
    periodoDatas: "Data da infração",
  }
}

function ConsultaInfracao() {
  //State para consultar infração
  const [consultaInfracao, setConsultaInfracao] = useState(initialStateConsultaInfracao());

  //State das lista de infrações
  const [listaInfracoes, setListaInfracoes] = useState([]);

  //State para pegar lista dos tipos de fiscalizacao
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para pegar os perfil dos usuarios
  const [listUsuarios, setListUsuarios] = useState([]);

  //State para pegar os tipos de infrações
  const [infracoes, setInfracoes] = useState([]);

  //Estado de controle dos campos de erro
  const [errors, setErrors] = useState({});

  //Objeto token
  const session = getSessionCookie();

  const { setLoading } = useAuth();

  //Estado que pega os dados passados via navegação
  const location = useLocation();

  //Estado de navegação
  const navigate = useNavigate();

  //pegando a etapa selecionada no 
  const { filtro } = location.state ? location.state : {};

  //Cabeçalhos da lista de consulta infração
  const headers = [
    { value: "Tipo de fiscalização", objectValue: "tipoFiscalizacao_Identificacao", align: "left" },
    { value: "Infração", objectValue: "infracao", align: "left" },
    { value: "Número da infração", objectValue: "numeroInfracao", align: "left" },
    { value: "Nome do infrator", objectValue: "nomeInfrator", align: "left" },
    { value: "Documento do infrator", objectValue: "documentoIdentificacao", align: "left" },
    { value: "Endereço", objectValue: "enderecoCompleto", align: "left" },
    { value: "Data da infração", objectValue: "dataInfracao", align: "left" },
    { value: "Usuário", objectValue: "usuario_Nome", align: "left" },
    { value: "Situação", objectValue: "situacao", align: "left" },
    { value: "Status Boleto", objectValue: "statusBoleto", align: "left" }
  ];

  const [situacao, setSituacao] = useState([]);

  //Estado de controle dos campos obrigatorios 
  const [campos] = useState([
    objCampo({ name: "tipoFiscalizacao_Ids", required: true })
  ]);

  const VisualizarInfracao = (infracao) => {
    navigate("/admin/ficha-infracao", { state: { infracao_id: infracao.id, filtro: consultaInfracao, originPath: "/admin/consultInfracao" } })
  }

  //Variavel que guarda as ações da tabela
  const actions = [actionsTable.visualizar(VisualizarInfracao)];

  //Carregar tipos da fiscalização
  const loadTipoDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFiscalizacao_api.getList()
      .then(response => {
        response.data.map(value => {
          value.value = value.id;
          value.label = value.identificacao;
          return value;
        })
        setListTipoDeFiscalizacao(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  };

  //Função que carregar os usuários
  const loadUsuarios = () => {
    setLoading(true);
    usuario_api.getList().then(response => {
      response.data.map(value => {
        value.value = value.id;
        value.label = value.nome;
        return value;
      })
      setListUsuarios(response.data);
    })
      .catch(e => showMessage("Erro", e.message, "error", null))
      .finally(f => setLoading(false));
  };

  const loadInfracoes = () => {
    infracoes_api.getListAtivos().then(response => {
      response.data.map(value => {
        value.value = value.id;
        value.label = value.identificacao;
        return value;
      })
      setInfracoes(response.data);
    })
      .catch(e => showMessage("Erro", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  useEffect(() => {
    loadTipoDeFiscalizacao();
    loadUsuarios();
    loadInfracoes();

    if (filtro) {
      setConsultaInfracao({ ...filtro });
      handleConsultaInfracao(filtro);
      if (filtro.tipoFiscalizacao_Ids?.length > 0)
        loadSituacoes(filtro.tipoFiscalizacao_Ids);
    }
  }, []);

  //Função que carrega a união das situações de todos os tipos de fiscalização selecionados
  const loadSituacoes = (tipoFiscalizacao_Ids) => {
    const ids = tipoFiscalizacao_Ids ?? [];

    if (ids.length === 0) {
      setSituacao([]);
      return;
    }

    setLoading(true);
    Promise.all(ids.map(id => tipoDeFiscalizacao_api.GetSituacoes(id)))
      .then(responses => {
        const todas = responses.flatMap(response => response.data ?? []);
        const distintas = Array.from(new Set(todas)).map(value => ({ value: value, label: value }));
        const opcoes = [{ value: "Cancelada", label: "Cancelada" }, ...distintas];

        setSituacao(opcoes);

        //Limpa a situação selecionada quando ela não existe mais no conjunto dos tipos escolhidos
        setConsultaInfracao(anterior =>
          !anterior.situacao || opcoes.some(opcao => opcao.value === anterior.situacao)
            ? anterior
            : { ...anterior, situacao: "" });
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  //Função para campos select de múltipla escolha
  const onChangeMultiSelect = criarOnChangeMultiSelect({
    state: consultaInfracao,
    setState: setConsultaInfracao,
    campos,
    errors,
    setErrors,
    aoAlterar: (novoFiltro, e) => {
      if (e.name !== 'tipoFiscalizacao_Ids')
        return null;

      loadSituacoes(novoFiltro.tipoFiscalizacao_Ids);

      //Sem tipo selecionado não há situação possível, então o campo é limpo junto
      return novoFiltro.tipoFiscalizacao_Ids.length === 0 ? { situacao: "" } : null;
    }
  });

  //Função para campos select
  const onChangeSelect = (value, e) => {
    const _consultaInfracao = {
      ...consultaInfracao,
      [e.name]: value ? value.value.toString() : null,
    }

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name == e.name);
    const fieldError = validarCampos(_consultaInfracao, _campos);

    const _errors = { ...errors };
    delete _errors[e.name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setConsultaInfracao(_consultaInfracao);
  }

  //Função para campos sem ser select
  const onChange = (e) => {
    const { name, value } = e.target;
    setConsultaInfracao({
      ...consultaInfracao,
      [name]: value
    })
  }

  //Função para listar as fiscalizações com base nos filtros
  const handleConsultaInfracao = (filtro = null) => {

    if (!filtro) {
      //Realizando a validação dos campos obrigatorios
      const camposValidacao = [];

      if (!consultaInfracao.numeroInfracao?.trim()) {
        camposValidacao.push(
          objCampo({ name: "tipoFiscalizacao_Ids", required: true })
        );
      }

      const _errors = validarCampos(consultaInfracao, camposValidacao);
      setErrors(_errors[0]);

      if (_errors[1].length > 0)
        return true;

      //Data Inicial/Final são opcionais quando Nome do Infrator, Número da Infração ou CPF/CNPJ forem informados
      const possuiFiltroAlternativo = !!(consultaInfracao.nomeInfrator?.trim() || consultaInfracao.numeroInfracao?.trim() || consultaInfracao.cpfcnpj?.trim());

      if (!possuiFiltroAlternativo && (!consultaInfracao.dataInfracaoInicial || !consultaInfracao.dataInfracaoFinal)) {
        showMessage("Aviso", "Informe o período de datas ou ao menos um dos filtros: Nome do Infrator, Número da Infração ou CPF/CNPJ.", "warning", null);
        return true;
      }

      if (consultaInfracao.dataInfracaoInicial && consultaInfracao.dataInfracaoFinal &&
        isDateOverflow(consultaInfracao.dataInfracaoInicial, consultaInfracao.dataInfracaoFinal, 12, 'months')) {
        showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null);
        return true;
      }
    }

    setLoading(true)
    infracoes_api.GetConsultaInfracao(filtro != null ? filtro : consultaInfracao)
      .then(response => {
        response.data?.map(value => {
          value.dataInfracao = formatDataHora(value.dataInfracao);
        })
        setListaInfracoes(response.data);
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false))
  };

  return <>
    <h4 className='text-secondary m-0'>Consulta Infração</h4>
    <Row className='mt-3'>
      <Col md={12} lg={5}>
        <TextField
          type={"select"}
          name={"tipoFiscalizacao_Ids"}
          label={"* Tipo de fiscalização"}
          multiple
          options={listTipoDeFiscalizacao}
          onChange={onChangeMultiSelect}
          value={listTipoDeFiscalizacao.filter(value => (consultaInfracao.tipoFiscalizacao_Ids ?? []).includes(value.value))}
          invalid={!!consultaInfracao.numeroInfracao?.trim() ? false : !!errors.tipoFiscalizacao_Ids}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          name={"infracao_Id"}
          label={"Infração"}
          placeholder='TODOS'
          searchable
          options={infracoes}
          onChange={onChangeSelect}
          value={infracoes.filter(value => value.value == consultaInfracao.infracao_Id)}
          invalid={!!errors.infracao_Id}
        />
      </Col>
      <Col md={12} lg={3}>
        <TextField
          type={"select"}
          name={"situacao"}
          label={"Situação"}
          placeholder='TODOS'
          searchable
          options={situacao}
          value={situacao.filter(value => value.value == consultaInfracao.situacao)}
          onChange={onChangeSelect}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"text"}
          name={"numeroInfracao"}
          label={"Número da infração"}
          onChange={onChange}
          value={consultaInfracao.numeroInfracao}
          maxLength={30}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"text"}
          name={"nomeInfrator"}
          label={"Nome do Infrator"}
          onChange={onChange}
          value={consultaInfracao.nomeInfrator}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          name="cpfcnpj"
          label={"CPF/CNPJ"}
          value={consultaInfracao.cpfcnpj}
          onChange={onChange}
          mask={mascaras.cpfcnpjMask}
          maxLength={18}
        />
      </Col>
      <Col md={12} lg={4} className={session != null && session.realizaFiscalizacao ? "d-none" : ""}>
        <TextField
          type={"select"}
          name={"usuario_Id"}
          label={"Usuario"}
          searchable
          options={listUsuarios}
          onChange={onChangeSelect}
          value={listUsuarios.filter(value => value.value == consultaInfracao.usuario_Id)}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          name={"periodoDatas"}
          label={"* Período de Datas"}
          onChange={onChange}
          options={[
            { label: "Data Lavratura", value: "Data Lavratura" },
            { label: "Data da infração", value: "Data da infração" },
          ]}
          value={consultaInfracao.periodoDatas}
        />
      </Col>
      <Col md={12} lg={2}>
        <TextField
          type={"date"}
          name={"dataInfracaoInicial"}
          label={"Data Inicio"}
          onChange={onChange}
          value={consultaInfracao.dataInfracaoInicial}
        />
      </Col>
      <Col md={12} lg={2}>
        <TextField
          type={"date"}
          name={"dataInfracaoFinal"}
          label={"Data Final"}
          onChange={onChange}
          value={consultaInfracao.dataInfracaoFinal}
        />
      </Col>
    </Row>
    <Row className='text-center align-items-center mb-3'>
      <Col md={12} lg={12}>
        <Button
          color='primary'
          className='text-white fw-bold'
          onClick={() => handleConsultaInfracao()}
        >
          <FontAwesomeIcon icon={faFilter} /> Filtrar
        </Button>
      </Col>
    </Row>
    <TabelaListagem
      actions={actions}
      title={"Lista de infrações"}
      options={{ print: false, search: true, pagination: true }}
      headers={headers}
      items={listaInfracoes}
    />
  </>;
}

export default ConsultaInfracao;
